import * as r from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/ArrowCircleUp.es.js";
const o = r.forwardRef((e, c) => /* @__PURE__ */ r.createElement(t, { ref: c, ...e, weights: a }));
o.displayName = "ArrowCircleUpIcon";
const p = o;
export {
  p as ArrowCircleUp,
  o as ArrowCircleUpIcon
};
